module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAAHlBMVEVmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmb2HXvaAAAACXRSTlMAChUWl5iZ09TAduSjAAAAhElEQVQY02WPwQ2AMAhFiV3BeDaeOoJreHQNR/CkAxh1W4sU/w82aQq8FwrS9oLTTDIvlOdD8gmh2ddyIeSrMAiKhYQXQzCMt2IPvOzRhy0ENoGwCgNhFTbGRbgZ//Loh37xvzBPnDfs48FYBReT1dHIBPR5Bd5bBZ5DhZkXGQ/peI80PSDSNMzB5gL7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/btn-close.png
// module id = 588
// module chunks = 0